import React from 'react';
import Modal from '@Shared.Angular/flowingly.components/Modal/Modal';

type Props = {
  componentTypeName: string;
  flowModelNames: string[];
  onClose: () => void;
};

export const RunnerSetupDeleteComponentWarningModal = (props: Props) => {
  const { componentTypeName, flowModelNames, onClose } = props;

  return (
    <Modal
      id="component-delete-warning-modal"
      title="Delete Component"
      onClose={onClose}
      onActionClick={onClose}
      actionButtonText="Close"
      hideCancelButton={true}
    >
      <div className="component-delete-warning">
        <div className="component-delete-warning__message">
          This {componentTypeName} Component cannot be deleted as it's used by
          the following published Flow Models.
        </div>
        <ul
          className="component-delete-warning__list"
          data-testid="component-delete-warning-list"
        >
          {flowModelNames.map((flowModelName: string, index: number) => (
            <li
              key={`${flowModelName}-${index}`}
              data-testid={`component-delete-warning-item-${index}`}
            >
              {flowModelName}
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};
